import React from 'react';

import { Asset } from 'contentful';

import { Heading } from '../../../Heading/Heading';
import { Text } from '../../../Text/Text';
import { InvestorCard } from '../InvestorCard';

interface IProps {
  title?: string;
  displayDate?: string;
  description?: string;
  documents?: (Asset<'WITHOUT_UNRESOLVABLE_LINKS'> | undefined)[] | undefined;
}

export const InvestorSection = ({ title, displayDate, description, documents }: IProps) => {
  return (
    <div className="mt-12 md:mt-20">
      <Heading variant="sm" className="mb-6">
        {title}
      </Heading>
      {description && <Text>{description}</Text>}

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:grid-cols-4">
        {documents?.map(document => {
          if (document === undefined) {
            return <></>;
          }
          const { title: documentTitle, file } = document.fields;
          const { id } = document.sys;
          const url = file?.url;
          return documentTitle && url ? (
            <InvestorCard
              url={url}
              key={id}
              documentTitle={documentTitle}
              displayDate={displayDate}
            />
          ) : (
            <></>
          );
        })}
      </div>
    </div>
  );
};
